import { Component, Input, OnInit } from '@angular/core';
import { EventEmitter, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
export class SelectedDates {
	startDate: NgbDate | null;
	endDate: NgbDate | null;
}
@Component({
	selector: 'app-custom-date-range-picker',
	templateUrl: './custom-date-range-picker.component.html',
	styleUrls: ['./custom-date-range-picker.component.scss'],
	// imports:[CommonModule,NgbDatepickerModule],
	encapsulation: ViewEncapsulation.None,
})
export class CustomDateRangePickerComponent implements OnInit {
	@Output() selectedDates: EventEmitter<SelectedDates> = new EventEmitter<SelectedDates>();
	@Output() emitDateClear: EventEmitter<any> = new EventEmitter<any>();
	@Input() inputLabel: string = '';
	@Input() clearIconType: 'ResetIcon' | 'CrossIcon' = 'ResetIcon';
	@Input() size: 'default' | 'sm' = 'default';
	@Input() adjustPopupPosition: string = '';
	@Input() inputDate: string | null = "";
	@Input() adjustStyleTab: string | null = "";

	maxDate: NgbDateStruct;
	minDate: NgbDateStruct;

	hoveredDate: NgbDate | null = null;

	fromDate: NgbDate | null;
	toDate: NgbDate | null;

	@ViewChild("datepicker") dp: NgbInputDatepicker;

	constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter) {
		this.onClear();
	}

	ngOnInit(): void {
		if (this.inputDate) {
			const [start, end] = this.inputDate.split(' - ');

			const [startMonth, startDay, startYear] = start.split('/').map(Number);
			const [endMonth, endDay, endYear] = end.split('/').map(Number);

			this.fromDate = new NgbDate(startYear, startMonth, startDay);
			this.toDate = new NgbDate(endYear, endMonth, endDay);
		} else {
			this.inputDate = '';
		}
	}

	// onDateSelection1(date: NgbDate) {
	// 	if (!this.fromDate && !this.toDate) {
	// 		this.fromDate = date;
	// 	} else if (this.fromDate && !this.toDate && date) {
	// 		if (date.before(this.fromDate)) {
	// 			this.fromDate = date;
	// 		} else {
	// 			this.toDate = date;
	// 		}
	// 	} else {
	// 		this.toDate = null;
	// 		this.fromDate = date;
	// 	}
	// 	this.inputDate = this.formatter.format(this.fromDate) + ' - ' + this.formatter.format(this.toDate);
	// }
	onDateSelection(date: NgbDate) {
		if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		}
		else if (this.fromDate && !this.toDate) {
			if (date.equals(this.fromDate)) {
				this.toDate = this.fromDate;
			} else if (date.after(this.fromDate)) {
				this.toDate = date;
			} else {
				this.fromDate = date;
				this.toDate = null;
			}
		}
		else {
			this.fromDate = date;
			this.toDate = null;
		}
		if (this.fromDate && this.toDate) {
			this.inputDate = `${this.formatter.format(this.fromDate)} - ${this.formatter.format(this.toDate)}`;
		} else if (this.fromDate) {
			this.inputDate = this.formatter.format(this.fromDate);
		} else {
			this.inputDate = '';
		}
		// this.inputDate = this.formatter.format(this.fromDate) + ' - ' + this.formatter.format(this.toDate);

	}

	isHovered(date: NgbDate) {
		return (
			this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
		);
	}
	isInside(date: NgbDate) {
		return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
	}
	isRange(date: NgbDate) {
		return (
			date.equals(this.fromDate) ||
			(this.toDate && date.equals(this.toDate)) ||
			this.isInside(date) ||
			this.isHovered(date)
		);
	}
	isStartDate(date: NgbDate) {
		return date.equals(this.fromDate);
	}
	isEndDate(date: NgbDate) {
		return date.equals(this.toDate);
	}
	onClear() {
		this.inputDate = null;
		this.fromDate = null;
		this.toDate = null;

		this.emitDateClear.emit();
	}
	onApply() {
		this.selectedDates.emit({
			startDate: this.fromDate,
			endDate: this.toDate
		});
		this.dp.close();

		setTimeout(() => {
			if (!this.fromDate && !this.toDate) {
				this.inputDate = '';
			}
		}, 0);
	}
}

